module.exports = __webpack_public_path__ + "static/dmon-artist-profile-medium-9372d87beb3def4204f1e429f9a24b5b.jpg";